// cart page block

if (location.pathname === '/cart' && !location.search) {
	window.location.href = '/?return_link=cart';
}

// Open cart drawer when redirected with ?return_link=cart
if (new URLSearchParams(location.search).has('return_link')) {
	const cartDrawerObserver = new MutationObserver(() => {
		let cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.show();
			cartDrawerObserver.disconnect(); // Stop observing after cart opens
		}
	});
	cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

	// Remove return_link=cart from the URL
	const newUrl = location.href.replace(/[?&]return_link=cart/g, '');
	history.replaceState({}, document.title, newUrl);
}

// Handle browser back button to close cart
window.addEventListener('popstate', function (event) {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !location.search.includes('cartOpen=true')) {
		cartDrawer.close();
	} else if (event.state?.cart === 'show' && cartDrawer) {
		cartDrawer.show();
	}
});

// Ensure cartOpen=true is removed from URL if cart is closed
document.addEventListener('DOMContentLoaded', () => {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !cartDrawer.classList.contains('active')) {
		const newUrl = location.href.replace(/[?&]cartOpen=true/g, '');
		history.replaceState({}, document.title, newUrl);
	}
});

// Open cart and push cartOpen=true into history
function openCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer) {
		cartDrawer.show();
		history.pushState({ cart: 'show' }, '', '?cartOpen=true');
	}
}


// cart-change-handler.js
document.addEventListener('cart:change', async (event) => {
	const cartData = event.detail.cart;
	const baseEvent = event.detail.baseEvent;

	console.log('Base Event:', baseEvent);  

	// First handle the case of removing add-ons when main product is gone
	const mainProducts = cartData.items.filter(item => !item.properties?._main_product);
	const addOns = cartData.items.filter(item => item.properties?._main_product);
	
	// If there are add-ons but no main products, remove ALL add-ons
	if (addOns.length > 0 && mainProducts.length === 0) {
		console.log("No main products exist but add-ons found. Removing all add-ons.");
		await forceRemoveAllAddons(addOns);
		return; // Exit early after handling this case
	}
	
	// Check if any add-ons have a main product that no longer exists
	if (addOns.length > 0 && mainProducts.length > 0) {
		const orphanedAddons = addOns.filter(addon => {
			// Find if this addon's main product still exists
			const mainProductExists = mainProducts.some(main => 
				main.handle === addon.properties._main_product
			);
			return !mainProductExists;
		});
		
		if (orphanedAddons.length > 0) {
			console.log("Found orphaned add-ons to remove:", orphanedAddons);
			await forceRemoveAllAddons(orphanedAddons);
			return; // Exit early after handling this case
		}
	}
	
	// Handle changes to the main product quantity
	if (baseEvent === 'line-item:change' || baseEvent === 'variant:add' || baseEvent === 'item:remove') {
		// For each main product
		for (const mainProduct of mainProducts) {
			// Find add-ons for this specific main product
			const relatedAddons = addOns.filter(addon => 
				addon.properties._main_product === mainProduct.handle
			);
			
			if (relatedAddons.length === 0) continue;
			
			// If main product quantity is 0, remove all its add-ons
			if (mainProduct.quantity === 0) {
				console.log(`Main product ${mainProduct.handle} has 0 quantity. Removing all its add-ons.`);
				await forceRemoveAllAddons(relatedAddons);
				continue;
			}
			
			// For ready-to-wear and gift wrap items, sync quantities
			const syncableAddons = relatedAddons.filter(addon => {
              console.log('addon==',addon);
				const isReadyToWear = 
					(addon.product_title && addon.product_title.toLowerCase().includes('ready-to-wear')) ||
					(addon.product_title && addon.product_title.toLowerCase().includes('pre-drape')) ||
					(addon.product_title && addon.product_title.toLowerCase().includes('blouse-stitch')) ||
					(addon.product_title && addon.product_title.toLowerCase().includes('fall-edging')) ||
					(addon.variant_title && addon.variant_title.toLowerCase().includes('ready-to-wear'));
					
				const isGiftWrap = 
					(addon.handle === 'gift-wrapping') || 
					(addon.product_title && addon.product_title.toLowerCase().includes('gift wrap') && 
					!addon.product_title.toLowerCase().includes('gift box'));
					
				return isReadyToWear || isGiftWrap;
			});
			
			if (syncableAddons.length > 0) {
				// Check if any addon needs its quantity updated
				const needsSync = syncableAddons.some(addon => addon.quantity !== mainProduct.quantity);
				
				if (needsSync) {
					console.log(`Syncing ${syncableAddons.length} add-ons for main product ${mainProduct.handle}`);
					await syncAddonQuantities(syncableAddons, mainProduct.quantity);
				}
			}
		}
	}
	
	// Check for gift-wrapping items
	checkAndRemoveGiftWrappingItems(cartData);
});

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
	if (!addons || addons.length === 0) return;
	
	document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
	
	try {
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			}),
		);
		
		// Build updates object with all quantities set to 0
		const updates = {};
		addons.forEach(addon => {
			updates[addon.key] = 0;
		});
		
		console.log("Removing add-ons with updates:", updates);
		
		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				updates,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});
		
		if (!response.ok) throw new Error('Failed to update cart');
		
		const updatedCartContent = await response.json();
		console.log("Cart updated after removing add-ons:", updatedCartContent);
		
		// Dispatch cart change event to update the UI
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:refresh', {
				bubbles: true,
			}),
		);
		
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'item:remove',
					cart: updatedCartContent,
				},
			}),
		);
		
		// Update cart UI
		const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		if (cart && typeof cart.renderContents === 'function') {
			cart.renderContents(updatedCartContent);
		}
	} catch (error) {
		console.error('Error removing add-ons:', error);
	} finally {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
	}
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
	if (!addons || addons.length === 0) return;
	
	document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
	
	try {
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			}),
		);
		
		// Update all addons to the new quantity
		const updates = {};
		addons.forEach(addon => {
			updates[addon.key] = newQuantity;
		});
		
		console.log("Syncing addons with updates:", updates);
		
		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				updates,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});
		
		if (!response.ok) throw new Error('Failed to update cart');
		
		const updatedCartContent = await response.json();
		console.log("Cart updated after syncing addons:", updatedCartContent);
		
		// Rebuild cart UI
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'item:update',
					cart: updatedCartContent,
				},
			}),
		);
		
		// Force update cart UI
		const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		if (cart && typeof cart.renderContents === 'function') {
			cart.renderContents(updatedCartContent);
		}
	} catch (error) {
		console.error('Error syncing addon quantities:', error);
	} finally {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
	}
}




class ProductAddonCart extends HTMLElement {
	constructor() {
		super();
		this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		this.productHandle = this.dataset.productHandle;
		this.addEventListener('click', this.handleClick.bind(this));
		this.selectedVariantId = this.dataset.productSelectedVariant;
		
		// Set default values for selects if not already set
		this.setDefaultValues();
		
		this.setupEventListeners();
	}

	setDefaultValues() {
		// Set default values for all selects if they don't have a value
		this.querySelectorAll('select').forEach(select => {
			if (!select.value && select.options.length > 0) {
				// First check if there's a selected option in HTML
				const selectedOption = select.querySelector('option[selected]');
				if (selectedOption) {
					select.value = selectedOption.value;
				} else {
					// Otherwise select first option
					select.selectedIndex = 0;
				}
			}
		});
	}

	setupEventListeners() {
        //Blouse stitch
		const blouseStitchCheckbox = this.querySelector('.blouse-stitch-checkbox');
		const blouseStitchFields = this.querySelector('.blouse-stitch-fields');
		const blouseStitchMessageContainer = this.querySelector('.blouse-stitch-message-container');
		
		if (blouseStitchCheckbox && blouseStitchFields) {
			blouseStitchCheckbox.addEventListener('change', () => {
				blouseStitchFields.classList.toggle('hidden', !blouseStitchCheckbox.checked);
				blouseStitchMessageContainer.classList.toggle('hidden', !blouseStitchCheckbox.checked);
				this.toggleAddToCartButton();
			});
		}

      
		// Pre-drape fields toggle
		const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
		const preDrapeFields = this.querySelector('.pre-drape-fields');
		const preDrapeMessageContainer = this.querySelector('.pre-drape-message-container');
		
		if (preDrapeCheckbox && preDrapeFields) {
			preDrapeCheckbox.addEventListener('change', () => {
				preDrapeFields.classList.toggle('hidden', !preDrapeCheckbox.checked);
				preDrapeMessageContainer.classList.toggle('hidden', !preDrapeCheckbox.checked);
				this.toggleAddToCartButton();
			});
		}

        //fall edging
		const fallEdgeCheckbox = this.querySelector('.fallAndEdging-checkbox');
		const fallEdgeFields = this.querySelector('.fallAndEdging-fields');
		const fallEdgeMessageContainer = this.querySelector('.fallAndEdging-message-container');
		
		if (fallEdgeCheckbox && fallEdgeFields) {
			fallEdgeCheckbox.addEventListener('change', () => {
				fallEdgeFields.classList.toggle('hidden', !fallEdgeCheckbox.checked);
				fallEdgeMessageContainer.classList.toggle('hidden', !fallEdgeCheckbox.checked);
				this.toggleAddToCartButton();
			});
		}
      
		// Gift options toggle
		const giftSelectionCheckbox = this.querySelector('.gift-selection-checkbox');
		const giftOptionsContainer = this.querySelector('.gift-options');
		const giftMessageContainer = this.querySelector('.gift-message-container');

		if (giftSelectionCheckbox && giftOptionsContainer) {
			giftSelectionCheckbox.addEventListener('change', () => {
				giftOptionsContainer.classList.toggle('hidden', !giftSelectionCheckbox.checked);

				// Uncheck all individual gift option checkboxes if main checkbox is unchecked
				if (!giftSelectionCheckbox.checked) {
					this.querySelectorAll('.gift-option-checkbox').forEach((checkbox) => {
						checkbox.checked = false;
					});
					giftMessageContainer.classList.add('hidden');
				}

				this.toggleAddToCartButton();
			});
		}

		// Individual gift option checkboxes
		this.querySelectorAll('.gift-option-checkbox').forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				const anyGiftOptionChecked = Array.from(this.querySelectorAll('.gift-option-checkbox')).some(
					(checkbox) => checkbox.checked
				);
				giftMessageContainer.classList.toggle('hidden', !anyGiftOptionChecked);
				this.toggleAddToCartButton();
			});
		});

		// Main matching addon toggle
		const matchingAddonCheckbox = this.querySelector('.matching-addon-checkbox');
		const addonOptionsContainer = this.querySelector('.addon-options');

		if (matchingAddonCheckbox && addonOptionsContainer) {
			matchingAddonCheckbox.addEventListener('change', () => {
				addonOptionsContainer.classList.toggle('hidden', !matchingAddonCheckbox.checked);

				// Uncheck all individual addon checkboxes if main checkbox is unchecked
				if (!matchingAddonCheckbox.checked) {
					this.querySelectorAll('.addon-checkbox').forEach((checkbox) => {
						checkbox.checked = false;
						this.toggleAddonFields(checkbox);
					});
				}

				this.toggleAddToCartButton();
			});
		}

		// Individual addon checkboxes
		this.querySelectorAll('.addon-checkbox').forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				this.toggleAddonFields(checkbox);
				this.toggleAddToCartButton();
			});
		});

	}

	toggleAddonFields(checkbox) {
		const addonOption = checkbox.closest('.addon-option');
		const addonFields = addonOption.querySelector('.addon-fields');

		if (addonFields) {
			addonFields.classList.toggle('hidden', !checkbox.checked);
		}
	}

	toggleAddToCartButton() {
		const isAnyCheckboxChecked =
			this.querySelector('.pre-drape-checkbox:checked') ||
			this.querySelector('.blouse-stitch-checkbox:checked') ||
			this.querySelector('.fallAndEdging-checkbox:checked') ||
			this.querySelector('.addon-checkbox:checked') ||
			this.querySelector('.gift-option-checkbox:checked');

		const button = this.querySelector('product-addon-cart .button');
		const mainATC = document.querySelector('.product .product-info__block-item:is([data-block-type=buy-buttons])');
		const mainContainer = document.querySelector('product-addon-cart .addon-container');

		if (button) {
			button.classList.toggle('hidden', !isAnyCheckboxChecked);
			mainContainer.classList.toggle('on-checked-container', isAnyCheckboxChecked);
			mainATC.classList.toggle('hidden', isAnyCheckboxChecked);
		}
	}

	validateFields() {
		let isValid = true;
		const errors = [];

		const blouseStitchCheckbox = this.querySelector('.blouse-stitch-checkbox');
		if (blouseStitchCheckbox?.checked) {
			const sizeSelect = this.querySelector('.blouse-stitch-size');
			if (!sizeSelect.value || sizeSelect.value === '') {
				errors.push('Invalid size selection');
				isValid = false;
			}
		}
      
		const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
		if (preDrapeCheckbox?.checked) {
			const sizeSelect = this.querySelector('.pre-drape-size');
			if (!sizeSelect.value || sizeSelect.value === '') {
				errors.push('Invalid size selection');
				isValid = false;
			}
		}

        //fall nad edging
        const fallEdgeCheckbox = this.querySelector('.fallAndEdging-checkbox');
		if (fallEdgeCheckbox?.checked) {
			const sizeSelect = this.querySelector('.fallAndEdging-size');
			if (!sizeSelect.value || sizeSelect.value === '') {
				errors.push('Invalid size selection');
				isValid = false;
			}
		}
      
		if (!isValid) {
			alert(errors.join('\n'));
		}

		return isValid;
	}

	resetForm() {
		// Uncheck all checkboxes
		this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
			checkbox.checked = false;
		});

		// Reset all select elements to their first options
		this.querySelectorAll('select').forEach((select) => {
			if (select.options.length > 0) {
				// If the select has a selected option (from HTML), maintain that selection
				const selectedOption = select.querySelector('option[selected]');
				if (selectedOption) {
					select.value = selectedOption.value;
				} else {
					// Otherwise select the first option
					select.selectedIndex = 0;
				}
			}
		});

		// Clear all input fields that are not selects
		this.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
			input.value = '';
		});

		// Hide all addon fields
		this.querySelectorAll('.addon-fields, .pre-drape-fields, .gift-message-container, .pre-drape-message-container, .blouse-stitch-fields, .blouse-stitch-message-container, .fallAndEdging-fields, .fallAndEdging-message-container').forEach((field) => {
			field.classList.add('hidden');
		});

		// Hide addon options
		const addonOptionsContainer = this.querySelector('.addon-options');
		if (addonOptionsContainer) {
			addonOptionsContainer.classList.add('hidden');
		}

		// Hide gift options
		const giftOptionsContainer = this.querySelector('.gift-options');
		if (giftOptionsContainer) {
			giftOptionsContainer.classList.add('hidden');
		}

		// Toggle the add-to-cart button
		this.toggleAddToCartButton();
	}

	async handleClick(event) {
		if (!event.target.matches('button')) return;

		event.preventDefault();

		if (!this.validateFields()) return;

		// Add loading spinner to body
		document.body.classList.add('loading-spinner');
		
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
		
		try {
			await this.addProductsToCart();
		} catch (error) {
			console.error('Error adding products to cart:', error);
			alert(error.message || 'An error occurred while adding products to cart');
		} finally {
			document.body.classList.remove('loading-spinner');
			this.resetForm();
			document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
		}
	}

	async addProductsToCart() {
		const mainProductTitle = this.productHandle;
		const mainProductQuantity = document.querySelector('input[name="quantity"]')?.value || 1;

		const items = [];

		// Add main product using stored variant ID
		items.push({
			id: this.selectedVariantId,
			quantity: parseInt(mainProductQuantity),
			properties: {}, // Will be populated based on selected addons
		});

        // Add blouse-stitch if selected
		const blouseStitchSection = this.querySelector('.blouse-stitch-section');
		if (blouseStitchSection && this.querySelector('.blouse-stitch-checkbox').checked) {
			const sizeSelect = this.querySelector('.blouse-stitch-size');
			const blouseStitchMessage = this.querySelector('.blouse-stitch-message-input').value.trim();
			
			// Get the variant ID for the selected size
			const selectedSize = sizeSelect.value;
			
			items.push({
				id: selectedSize,
				quantity: 1,
				properties: {
					_main_product: mainProductTitle,
					...(blouseStitchMessage ? { instructions: blouseStitchMessage } : {}),
				},
			});
			items[0].properties._has_blouse_stitch = 'Yes';
		}
      
		// Add pre-drape if selected
		const preDrapeSection = this.querySelector('.pre-drape-section');
		if (preDrapeSection && this.querySelector('.pre-drape-checkbox').checked) {
			const sizeSelect = this.querySelector('.pre-drape-size');
			const preDrapeMessage = this.querySelector('.pre-drape-message-input').value.trim();
			
			// Get the variant ID for the selected size
			const selectedSize = sizeSelect.value;
			
			items.push({
				id: selectedSize,
				quantity: 1,
				properties: {
					_main_product: mainProductTitle,
					...(preDrapeMessage ? { instructions: preDrapeMessage } : {}),
				},
			});
			items[0].properties._has_pre_drape = 'Yes';
		}

        // Add fall-edging if selected
		const fallEdgeSection = this.querySelector('.fallAndEdging-section');
		if (fallEdgeSection && this.querySelector('.fallAndEdging-checkbox').checked) {
			const sizeSelect = this.querySelector('.fallAndEdging-size');
			const fallEdgeMessage = this.querySelector('.fallAndEdging-message-input').value.trim();
			
			// Get the variant ID for the selected size
			const selectedSize = sizeSelect.value;
			
			items.push({
				id: selectedSize,
				quantity: 1,
				properties: {
					_main_product: mainProductTitle,
					...(fallEdgeMessage ? { instructions: fallEdgeMessage } : {}),
				},
			});
			items[0].properties._has_fall_edge = 'Yes';
		}
      
		// Add addons if selected
		this.querySelectorAll('.addon-option').forEach((addonOption) => {
			const addonCheckbox = addonOption.querySelector('.addon-checkbox');
			if (addonCheckbox.checked) {
				const addonIndex = addonOption.dataset.addonIndex;
				const addonTitle = addonOption.dataset.productTitle;

				// Check if addon has size selection
				const sizeSelect = addonOption.querySelector('.addon-size');
				const selectedVariantId = sizeSelect ? sizeSelect.value : addonOption.dataset.variants.split(',')[0];

				items.push({
					id: selectedVariantId,
					quantity: 1,
				});

				// Add property to main item to indicate addon
				items[0].properties._has_addon = 'Yes';
			}
		});

		// Add gift options if selected
		this.querySelectorAll('.gift-option').forEach((giftOption) => {
			const giftCheckbox = giftOption.querySelector('.gift-option-checkbox');
			if (giftCheckbox.checked) {
				const giftVariantId = giftOption.dataset.variantId;
				items.push({
					id: giftVariantId,
					quantity: 1,
					properties: {
						_main_product: mainProductTitle,
					},
				});

				// Add property to main item to indicate gift
				items[0].properties._has_gift = 'Yes';
			}
		});

		// Add gift message if any gift option is selected
		const giftMessageInput = this.querySelector('.gift-message-input');
		if (giftMessageInput && giftMessageInput.value.trim() !== '') {
			items[0].properties.gift_message = giftMessageInput.value.trim();
		}

		// Prepare sections for cart update
		let sectionsToBundle = [];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			})
		);

		const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				items: items,
				sections: sectionsToBundle.join(','),
				sections_url: window.location.pathname,
			}),
		});

		const responseJson = await response.json();

		if (response.ok) {
			if (window.themeVariables.settings.cartType === 'page') {
				window.location.href = `${window.Shopify.routes.root}cart`;
				return;
			}

			const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
			cartContent.sections = responseJson.sections;

			// Dispatch cart events
			this.dispatchEvent(
				new CustomEvent('variant:add', {
					bubbles: true,
					detail: {
						items: responseJson.items || [responseJson],
						cart: cartContent,
					},
				})
			);

			document.documentElement.dispatchEvent(
				new CustomEvent('cart:change', {
					bubbles: true,
					detail: {
						baseEvent: 'variant:add',
						cart: cartContent,
					},
				})
			);
		} else {
			throw new Error(responseJson.description);
		}
	}
}

if (!window.customElements.get('product-addon-cart')) {
	window.customElements.define('product-addon-cart', ProductAddonCart);
}

// Add this function to check and remove gift-wrapping items when they're alone in cart
function checkAndRemoveGiftWrappingItems(cartData) {
	// Check if cart has items
	if (!cartData || !cartData.items || cartData.items.length === 0) return;
	
	// If there's only gift-wrapping items in the cart, remove them
	const giftWrappingItems = cartData.items.filter(item => 
		item.handle === 'gift-wrapping' || 
		item.product_title.toLowerCase().includes('gift wrap')
	);
	
	// If all items are gift-wrapping items, remove them
	if (giftWrappingItems.length > 0 && giftWrappingItems.length === cartData.items.length) {
		document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
		
		try {
			let sectionsToBundle = [];
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:prepare-bundled-sections', {
					bubbles: true,
					detail: { sections: sectionsToBundle },
				}),
			);
			
			// Prepare updates to set gift-wrapping quantities to 0
			const updates = giftWrappingItems.reduce((acc, item) => {
				acc[item.key] = 0;
				return acc;
			}, {});
			
			// Update cart to remove gift-wrapping items
			fetch(`${window.Shopify.routes.root}cart/update.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify({
					updates,
					sections: sectionsToBundle.join(','),
					sections_url: window.location.pathname,
				}),
			})
			.then(response => {
				if (!response.ok) throw new Error('Failed to update cart');
				return response.json();
			})
			.then(updatedCartContent => {
				// Dispatch cart change event to update the UI
				document.documentElement.dispatchEvent(
					new CustomEvent('cart:change', {
						bubbles: true,
						detail: {
							baseEvent: 'item:remove',
							cart: updatedCartContent,
						},
					}),
				);
				
				// Update cart UI
				const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			})
			.catch(error => {
				console.error('Error removing gift-wrapping items:', error);
				if (window.themeVariables?.settings.showErrorMessage) {
					alert(error.message);
				}
			})
			.finally(() => {
				document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
			});
		} catch (error) {
			console.error('Error checking gift-wrapping items:', error);
			document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
		}
	}
}

document.querySelectorAll('.product-offers__item .code svg').forEach(button => {
  button.addEventListener('click', () => {
    const codeDiv = button.closest('.code') || button.closest('*').closest('.code');
    if (codeDiv) {
      const text = codeDiv.innerText;
      navigator.clipboard.writeText(text);
    }
  });
});


//mobile search js
document.addEventListener("DOMContentLoaded", function () {
  // Handle clearing input when cross icon is clicked
  document.querySelectorAll('#predictive-search-form-mob dialog-close-button button').forEach(button => {
    button.addEventListener('click', function () {
      const headerSearch = this.closest('header-search');
      const input = headerSearch?.querySelector('input[type="search"]');
      if (input) {
        input.value = '';
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  });

  // Add or remove 'active' class based on input content
  const searchInput = document.querySelector('#header-search-mob input[type="search"]');
  const headerSearchMob = document.querySelector('#header-search-mob');

  if (searchInput && headerSearchMob) {
    searchInput.addEventListener('input', function () {
      if (this.value.trim().length > 0) {
        headerSearchMob.classList.add('active');
      } else {
        headerSearchMob.classList.remove('active');
      }
    });
  }
});

// header-sidebar js 
document.querySelectorAll('.header-sidebar__linklist summary').forEach(link => {
  link.addEventListener('click', function (event) {
    const clickedDetails = event.target.closest('details');
    const container = clickedDetails?.closest('.header-sidebar__linklist');
    if (!container) return;
    container.querySelectorAll('details').forEach(detail => {
      if (detail !== clickedDetails && detail.hasAttribute('open')) {
        detail.removeAttribute('open');
        detail.setAttribute('aria-expanded', false);
      }
    });
  });
});
